import React, { useEffect, useState } from 'react';
import {inject, observer} from "mobx-react";
import cx from 'classnames';

import api from '../../common/api';
import { BettingWidget } from './racebook-game';


const RacebookPage = ({store}) => {
    const viewSize = store.site.status.viewSize;

    const [racingData, setRacingData] = useState(null);

    useEffect(() => {
        api.games.getRacingToken().then(res => {
            // console.log(res);
            if (res.success) {
                setRacingData(res.data);
            } else {
            //     error
            }
        });
    }, []);


    return (
        <div className={cx('ll-page', `racebook-page--${viewSize}`)}>
            <div className={`racebook-iframe--${viewSize}`}>
                {racingData ? (
                    <BettingWidget
                        currencyCode={racingData.currencyCode}
                        tenantId={racingData.tenantId}
                        clientIdForWidgets={racingData.clientIdForWidgets}
                        userId={racingData.userId}
                        token={racingData.token}
                        url={racingData.url}
                        language={racingData.language}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default inject('store')(observer(RacebookPage));